import { render, staticRenderFns } from "./FilesPlaceholder.vue?vue&type=template&id=7342d608&"
import script from "./FilesPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FilesPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
